// extracted by css-extract-rspack-plugin
export default {"FeaturesTable":"FeaturesTable-module__FeaturesTable__ph8Uy","FeaturesTable__srOnly":"FeaturesTable-module__FeaturesTable__srOnly__jyIYt"};